import { useController, useFormContext } from 'react-hook-form'

import type { DateInputProps } from '../InputElements'
import { DateInput } from '../InputElements'

export function ReactHookFormDateField({
  name,
  disabled,
  ...rest
}: Omit<DateInputProps, 'error' | 'helperText' | 'onChange' | 'value'>) {
  const { control } = useFormContext()
  const {
    field: { onChange, value },
    fieldState: { error },
    formState: { isSubmitting },
  } = useController({ name, control })

  const isFieldDisabled = disabled || isSubmitting
  return (
    <DateInput
      {...rest}
      disabled={isFieldDisabled}
      error={!!error}
      helperText={error?.message ?? ''}
      name={name}
      onChange={onChange}
      value={value}
    />
  )
}
